"use strict";
"use client";

var _excluded = ["__scopeContextMenu", "disabled"],
  _excluded2 = ["__scopeContextMenu"],
  _excluded3 = ["__scopeContextMenu"],
  _excluded4 = ["__scopeContextMenu"],
  _excluded5 = ["__scopeContextMenu"],
  _excluded6 = ["__scopeContextMenu"],
  _excluded7 = ["__scopeContextMenu"],
  _excluded8 = ["__scopeContextMenu"],
  _excluded9 = ["__scopeContextMenu"],
  _excluded10 = ["__scopeContextMenu"],
  _excluded11 = ["__scopeContextMenu"],
  _excluded12 = ["__scopeContextMenu"],
  _excluded13 = ["__scopeContextMenu"],
  _excluded14 = ["__scopeContextMenu"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/context-menu/src/index.ts
var src_exports = {};
__export(src_exports, {
  Arrow: function Arrow() {
    return Arrow2;
  },
  CheckboxItem: function CheckboxItem() {
    return CheckboxItem2;
  },
  Content: function Content() {
    return Content2;
  },
  ContextMenu: function ContextMenu() {
    return _ContextMenu;
  },
  ContextMenuArrow: function ContextMenuArrow() {
    return _ContextMenuArrow;
  },
  ContextMenuCheckboxItem: function ContextMenuCheckboxItem() {
    return _ContextMenuCheckboxItem;
  },
  ContextMenuContent: function ContextMenuContent() {
    return _ContextMenuContent;
  },
  ContextMenuGroup: function ContextMenuGroup() {
    return _ContextMenuGroup;
  },
  ContextMenuItem: function ContextMenuItem() {
    return _ContextMenuItem;
  },
  ContextMenuItemIndicator: function ContextMenuItemIndicator() {
    return _ContextMenuItemIndicator;
  },
  ContextMenuLabel: function ContextMenuLabel() {
    return _ContextMenuLabel;
  },
  ContextMenuPortal: function ContextMenuPortal() {
    return _ContextMenuPortal;
  },
  ContextMenuRadioGroup: function ContextMenuRadioGroup() {
    return _ContextMenuRadioGroup;
  },
  ContextMenuRadioItem: function ContextMenuRadioItem() {
    return _ContextMenuRadioItem;
  },
  ContextMenuSeparator: function ContextMenuSeparator() {
    return _ContextMenuSeparator;
  },
  ContextMenuSub: function ContextMenuSub() {
    return _ContextMenuSub;
  },
  ContextMenuSubContent: function ContextMenuSubContent() {
    return _ContextMenuSubContent;
  },
  ContextMenuSubTrigger: function ContextMenuSubTrigger() {
    return _ContextMenuSubTrigger;
  },
  ContextMenuTrigger: function ContextMenuTrigger() {
    return _ContextMenuTrigger;
  },
  Group: function Group() {
    return Group2;
  },
  Item: function Item() {
    return Item2;
  },
  ItemIndicator: function ItemIndicator() {
    return ItemIndicator2;
  },
  Label: function Label() {
    return Label2;
  },
  Portal: function Portal() {
    return Portal2;
  },
  RadioGroup: function RadioGroup() {
    return RadioGroup2;
  },
  RadioItem: function RadioItem() {
    return RadioItem2;
  },
  Root: function Root() {
    return Root2;
  },
  Separator: function Separator() {
    return Separator2;
  },
  Sub: function Sub() {
    return Sub2;
  },
  SubContent: function SubContent() {
    return SubContent2;
  },
  SubTrigger: function SubTrigger() {
    return SubTrigger2;
  },
  Trigger: function Trigger() {
    return _Trigger;
  },
  createContextMenuScope: function createContextMenuScope() {
    return _createContextMenuScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/context-menu/src/ContextMenu.tsx
var React = __toESM(require("react"));
var import_primitive = require("@radix-ui/primitive");
var import_react_context = require("@radix-ui/react-context");
var import_react_primitive = require("@radix-ui/react-primitive");
var MenuPrimitive = __toESM(require("@radix-ui/react-menu"));
var import_react_menu = require("@radix-ui/react-menu");
var import_react_use_callback_ref = require("@radix-ui/react-use-callback-ref");
var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");
var import_jsx_runtime = require("react/jsx-runtime");
var CONTEXT_MENU_NAME = "ContextMenu";
var _ref = (0, import_react_context.createContextScope)(CONTEXT_MENU_NAME, [import_react_menu.createMenuScope]),
  _ref2 = _slicedToArray(_ref, 2),
  createContextMenuContext = _ref2[0],
  _createContextMenuScope = _ref2[1];
var useMenuScope = (0, import_react_menu.createMenuScope)();
var _createContextMenuCon = createContextMenuContext(CONTEXT_MENU_NAME),
  _createContextMenuCon2 = _slicedToArray(_createContextMenuCon, 2),
  ContextMenuProvider = _createContextMenuCon2[0],
  useContextMenuContext = _createContextMenuCon2[1];
var _ContextMenu = function _ContextMenu(props) {
  var __scopeContextMenu = props.__scopeContextMenu,
    children = props.children,
    onOpenChange = props.onOpenChange,
    dir = props.dir,
    _props$modal = props.modal,
    modal = _props$modal === void 0 ? true : _props$modal;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var menuScope = useMenuScope(__scopeContextMenu);
  var handleOpenChangeProp = (0, import_react_use_callback_ref.useCallbackRef)(onOpenChange);
  var handleOpenChange = React.useCallback(function (open2) {
    setOpen(open2);
    handleOpenChangeProp(open2);
  }, [handleOpenChangeProp]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ContextMenuProvider, {
    scope: __scopeContextMenu,
    open: open,
    onOpenChange: handleOpenChange,
    modal: modal,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Root, _objectSpread(_objectSpread({}, menuScope), {}, {
      dir: dir,
      open: open,
      onOpenChange: handleOpenChange,
      modal: modal,
      children: children
    }))
  });
};
_ContextMenu.displayName = CONTEXT_MENU_NAME;
var TRIGGER_NAME = "ContextMenuTrigger";
var _ContextMenuTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    triggerProps = _objectWithoutProperties(props, _excluded);
  var context = useContextMenuContext(TRIGGER_NAME, __scopeContextMenu);
  var menuScope = useMenuScope(__scopeContextMenu);
  var pointRef = React.useRef({
    x: 0,
    y: 0
  });
  var virtualRef = React.useRef({
    getBoundingClientRect: function getBoundingClientRect() {
      return DOMRect.fromRect(_objectSpread({
        width: 0,
        height: 0
      }, pointRef.current));
    }
  });
  var longPressTimerRef = React.useRef(0);
  var clearLongPress = React.useCallback(function () {
    return window.clearTimeout(longPressTimerRef.current);
  }, []);
  var handleOpen = function handleOpen(event) {
    pointRef.current = {
      x: event.clientX,
      y: event.clientY
    };
    context.onOpenChange(true);
  };
  React.useEffect(function () {
    return clearLongPress;
  }, [clearLongPress]);
  React.useEffect(function () {
    return void (disabled && clearLongPress());
  }, [disabled, clearLongPress]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Anchor, _objectSpread(_objectSpread({}, menuScope), {}, {
      virtualRef: virtualRef
    })), /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.span, _objectSpread(_objectSpread({
      "data-state": context.open ? "open" : "closed",
      "data-disabled": disabled ? "" : void 0
    }, triggerProps), {}, {
      ref: forwardedRef,
      style: _objectSpread({
        WebkitTouchCallout: "none"
      }, props.style),
      onContextMenu: disabled ? props.onContextMenu : (0, import_primitive.composeEventHandlers)(props.onContextMenu, function (event) {
        clearLongPress();
        handleOpen(event);
        event.preventDefault();
      }),
      onPointerDown: disabled ? props.onPointerDown : (0, import_primitive.composeEventHandlers)(props.onPointerDown, whenTouchOrPen(function (event) {
        clearLongPress();
        longPressTimerRef.current = window.setTimeout(function () {
          return handleOpen(event);
        }, 700);
      })),
      onPointerMove: disabled ? props.onPointerMove : (0, import_primitive.composeEventHandlers)(props.onPointerMove, whenTouchOrPen(clearLongPress)),
      onPointerCancel: disabled ? props.onPointerCancel : (0, import_primitive.composeEventHandlers)(props.onPointerCancel, whenTouchOrPen(clearLongPress)),
      onPointerUp: disabled ? props.onPointerUp : (0, import_primitive.composeEventHandlers)(props.onPointerUp, whenTouchOrPen(clearLongPress))
    }))]
  });
});
_ContextMenuTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "ContextMenuPortal";
var _ContextMenuPortal = function _ContextMenuPortal(props) {
  var __scopeContextMenu = props.__scopeContextMenu,
    portalProps = _objectWithoutProperties(props, _excluded2);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Portal, _objectSpread(_objectSpread({}, menuScope), portalProps));
};
_ContextMenuPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "ContextMenuContent";
var _ContextMenuContent = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    contentProps = _objectWithoutProperties(props, _excluded3);
  var context = useContextMenuContext(CONTENT_NAME, __scopeContextMenu);
  var menuScope = useMenuScope(__scopeContextMenu);
  var hasInteractedOutsideRef = React.useRef(false);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Content, _objectSpread(_objectSpread(_objectSpread({}, menuScope), contentProps), {}, {
    ref: forwardedRef,
    side: "right",
    sideOffset: 2,
    align: "start",
    onCloseAutoFocus: function onCloseAutoFocus(event) {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented && hasInteractedOutsideRef.current) {
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: function onInteractOutside(event) {
      var _props$onInteractOuts;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented && !context.modal) hasInteractedOutsideRef.current = true;
    },
    style: _objectSpread(_objectSpread({}, props.style), {
      "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
    })
  }));
});
_ContextMenuContent.displayName = CONTENT_NAME;
var GROUP_NAME = "ContextMenuGroup";
var _ContextMenuGroup = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    groupProps = _objectWithoutProperties(props, _excluded4);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Group, _objectSpread(_objectSpread(_objectSpread({}, menuScope), groupProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuGroup.displayName = GROUP_NAME;
var LABEL_NAME = "ContextMenuLabel";
var _ContextMenuLabel = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    labelProps = _objectWithoutProperties(props, _excluded5);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Label, _objectSpread(_objectSpread(_objectSpread({}, menuScope), labelProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuLabel.displayName = LABEL_NAME;
var ITEM_NAME = "ContextMenuItem";
var _ContextMenuItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    itemProps = _objectWithoutProperties(props, _excluded6);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Item, _objectSpread(_objectSpread(_objectSpread({}, menuScope), itemProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuItem.displayName = ITEM_NAME;
var CHECKBOX_ITEM_NAME = "ContextMenuCheckboxItem";
var _ContextMenuCheckboxItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    checkboxItemProps = _objectWithoutProperties(props, _excluded7);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.CheckboxItem, _objectSpread(_objectSpread(_objectSpread({}, menuScope), checkboxItemProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME;
var RADIO_GROUP_NAME = "ContextMenuRadioGroup";
var _ContextMenuRadioGroup = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    radioGroupProps = _objectWithoutProperties(props, _excluded8);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.RadioGroup, _objectSpread(_objectSpread(_objectSpread({}, menuScope), radioGroupProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuRadioGroup.displayName = RADIO_GROUP_NAME;
var RADIO_ITEM_NAME = "ContextMenuRadioItem";
var _ContextMenuRadioItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    radioItemProps = _objectWithoutProperties(props, _excluded9);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.RadioItem, _objectSpread(_objectSpread(_objectSpread({}, menuScope), radioItemProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuRadioItem.displayName = RADIO_ITEM_NAME;
var INDICATOR_NAME = "ContextMenuItemIndicator";
var _ContextMenuItemIndicator = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    itemIndicatorProps = _objectWithoutProperties(props, _excluded10);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.ItemIndicator, _objectSpread(_objectSpread(_objectSpread({}, menuScope), itemIndicatorProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuItemIndicator.displayName = INDICATOR_NAME;
var SEPARATOR_NAME = "ContextMenuSeparator";
var _ContextMenuSeparator = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    separatorProps = _objectWithoutProperties(props, _excluded11);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Separator, _objectSpread(_objectSpread(_objectSpread({}, menuScope), separatorProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME = "ContextMenuArrow";
var _ContextMenuArrow = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    arrowProps = _objectWithoutProperties(props, _excluded12);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Arrow, _objectSpread(_objectSpread(_objectSpread({}, menuScope), arrowProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuArrow.displayName = ARROW_NAME;
var SUB_NAME = "ContextMenuSub";
var _ContextMenuSub = function _ContextMenuSub(props) {
  var __scopeContextMenu = props.__scopeContextMenu,
    children = props.children,
    onOpenChange = props.onOpenChange,
    openProp = props.open,
    defaultOpen = props.defaultOpen;
  var menuScope = useMenuScope(__scopeContextMenu);
  var _ref3 = (0, import_react_use_controllable_state.useControllableState)({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    open = _ref4[0],
    setOpen = _ref4[1];
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.Sub, _objectSpread(_objectSpread({}, menuScope), {}, {
    open: open,
    onOpenChange: setOpen,
    children: children
  }));
};
_ContextMenuSub.displayName = SUB_NAME;
var SUB_TRIGGER_NAME = "ContextMenuSubTrigger";
var _ContextMenuSubTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    triggerItemProps = _objectWithoutProperties(props, _excluded13);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.SubTrigger, _objectSpread(_objectSpread(_objectSpread({}, menuScope), triggerItemProps), {}, {
    ref: forwardedRef
  }));
});
_ContextMenuSubTrigger.displayName = SUB_TRIGGER_NAME;
var SUB_CONTENT_NAME = "ContextMenuSubContent";
var _ContextMenuSubContent = React.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    subContentProps = _objectWithoutProperties(props, _excluded14);
  var menuScope = useMenuScope(__scopeContextMenu);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(MenuPrimitive.SubContent, _objectSpread(_objectSpread(_objectSpread({}, menuScope), subContentProps), {}, {
    ref: forwardedRef,
    style: _objectSpread(_objectSpread({}, props.style), {
      "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
    })
  }));
});
_ContextMenuSubContent.displayName = SUB_CONTENT_NAME;
function whenTouchOrPen(handler) {
  return function (event) {
    return event.pointerType !== "mouse" ? handler(event) : void 0;
  };
}
var Root2 = _ContextMenu;
var _Trigger = _ContextMenuTrigger;
var Portal2 = _ContextMenuPortal;
var Content2 = _ContextMenuContent;
var Group2 = _ContextMenuGroup;
var Label2 = _ContextMenuLabel;
var Item2 = _ContextMenuItem;
var CheckboxItem2 = _ContextMenuCheckboxItem;
var RadioGroup2 = _ContextMenuRadioGroup;
var RadioItem2 = _ContextMenuRadioItem;
var ItemIndicator2 = _ContextMenuItemIndicator;
var Separator2 = _ContextMenuSeparator;
var Arrow2 = _ContextMenuArrow;
var Sub2 = _ContextMenuSub;
var SubTrigger2 = _ContextMenuSubTrigger;
var SubContent2 = _ContextMenuSubContent;